<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
    <p>AmMap is an add-on to <a class="text-primary" href="https://www.amcharts.com/javascript-charts/" target="_blank">amCharts 4: Charts</a>.
        You can use it to add interactive, stunning, geographical maps to your websites or applications. Just like any other chart.</p>
    <docs-section [content]="componentContent"></docs-section>
</demo-section>
  